import React, { useState, useEffect } from "react";
import './Support.css'
import { validEmail } from '../../../../Constants/RegExp';
import {
  SupportTicket,
  GetConfig
} from './Requests'
import {PulseLoader } from "react-spinners";


  const Support = () => {
    let errorsObj = { subject: '', type: '', priority: '', emailAddress: '', phoneNumber: '', description: '' };
    const [errors, setErrors] = useState(errorsObj);
    const [subject, setSubject] = useState('')
    const [type, setType] = useState('Bug')
    const [priority, setPriority] = useState('Low')
    const [emailAddress, setEmailAddress] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [description, setDescription] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [config, setConfig] = useState()
    const [requestState, setRequestState] = useState(false)
    const [ticketRef, setTicketRef] = useState()

    useEffect(() => {
        GetConfigWrapper()
      }, []);
    
      
    function GetConfigWrapper()
    {
      GetConfig().then((res) => {
        if(res.status === 200)
        {
        setConfig(res.data)
        console.log(res.data)
        setEmailAddress(res.data.shopEmail)
        setPhoneNumber(res.data.phoneNumber)
        }
      }).catch((error) => {
      }).finally(() => {
        setIsLoading(false)
      })
    }

  const handleSubmit = (e) => {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };

    if (subject === '') {
      errorObj.subject = 'Subject is required';
      error = true;
    }

    if (type === '') {
      errorObj.type = 'Please select the type of request you are submitting';
      error = true;
    }

    if (priority === '') {
      errorObj.priority = 'Please select a priority for this request';
      error = true;
    }

    if (emailAddress === '') {
      errorObj.emailAddress = 'Email is required';
      error = true;
    }else
    {
      if (!validEmail.test(emailAddress))
        {
          errorObj.emailAddress = 'Invalid Email';
          error = true;
        }
    }

    if (description === '') {
      errorObj.description = 'Description of the issue is required';
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return
    } else {
      setIsLoading(true)
      const ticketRefNum = getRndInteger(1000, 900000)
      setTicketRef(ticketRefNum)
      SupportTicket(subject, type, priority, emailAddress, phoneNumber, description, ticketRefNum).then((res) => {
        if (res.status === 200)
        {
          setRequestState('success')
        }
      }).catch((error) => {
          setRequestState('failed')

      }).finally(() =>{
        setIsLoading(false)
      })
    }
  };

  function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min) ) + min;
}

    return (
    <div className="support-page">
        {isLoading ?
        <div className="support-container">
        <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
          <div
          className="test">        
            <PulseLoader 
            color={'#333'}
            loading={isLoading}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
            />
          </div>
      
        </div>
        </div>
      :
      requestState === false ?
      <div className="support-container">
        <p>Use the form below to report issues or request assistance.</p>
        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: "1.5rem"}}>
            <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                defaultValue=''
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            {errors.subject && <div className="text-danger fs-12">{errors.subject}</div>}
          </div>
          <div style={{marginBottom: "1.5rem"}}>
            <label htmlFor="type">Type</label>
              <select
                id="type"
                name="type"
                defaultValue='Bug'
                onChange={(e) => setType(e.target.value)}
              >
                <option value="Bug">Bug</option>
                <option value="Feature request">Feature request</option>
                <option value="Feedback">Feedback</option>
                <option value="Question">Question</option>
                <option value="Other">Other</option>
              </select>
              {errors.type && <div className="text-danger fs-12">{errors.type}</div>}
          </div>
          <div style={{marginBottom: "1.5rem"}}>
            <label htmlFor="priority">Priority</label>
              <select
                id="priority"
                name="priority"
                defaultValue='Low'
                onChange={(e) => setPriority(e.target.value)}
              >
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
                <option value="Critical">Critical</option>
              </select>
              {errors.priority && <div className="text-danger fs-12">{errors.priority}</div>}
          </div>
          <div style={{marginBottom: "1.5rem"}}>
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              defaultValue={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              required
            />
            {errors.emailAddress && <div className="text-danger fs-12">{errors.emailAddress}</div>}
          </div>
          <div style={{marginBottom: "1.5rem"}}>
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              defaultValue={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            {errors.phoneNumber && <div className="text-danger fs-12">{errors.phoneNumber}</div>}
          </div>
          <div style={{marginBottom: "1.5rem"}}>
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              maxLength={2000}
              rows="5"
              defaultValue=''
              onChange={(e) => setDescription(e.target.value)}
              required
            />
            {errors.description && <div className="text-danger fs-12">{errors.description}</div>}
          </div>
          <button onClick={handleSubmit} type="submit">Submit</button>
        </form>
      </div>
      :
      requestState === 'success'
      ?
      			// <div className="cancel-appointment-container">
            <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
        <div className="cancel-appointment-card">
		<div>     
		<div className="icon-wrapper">
          <span className="check-icon">&#10003;</span>
        </div>
            <h1>Support Ticket Raised</h1>
            <p>Your support ticket has been raised, we will be in contact soon.</p>
            <p>Ticket reference <strong>#{ticketRef}</strong></p>
        </div>
			</div>
			</div>
      :
      requestState === 'failed' ?
            <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
        <div className="cancel-appointment-card">
			<div>
            <div className="icon-problem-wrapper">
            <span className="problem-icon">&#x2718;</span>
            </div>
            <h1>Oh no!</h1>
            <p>There was an issue raising your support ticket. Please try again or administration</p>
            </div>
			</div>
			 </div>
			:
			<div></div>
      }


      </div>
    );
  };
  
  export default Support;